<ejs-maps height="100%" width="100%" [centerPosition]="centerPosition" [zoomSettings]="zoomSettings">
    <e-layers>
        <e-layer [urlTemplate]="urlTemplate" [markerSettings]="markerSettings"></e-layer>
    </e-layers>
</ejs-maps>